<button [ngClass]="getPillsClasses()">
  {{ label }}
</button>
